module.exports = __webpack_public_path__ + "img/high_pressure_warning.c0154995.svg";